import axios from "axios";
import Cookies from "js-cookie";
import { useState, useEffect } from "react";

export default function useUserJobStats() {
  const [userjobStats, setUserJobStats] = useState({
    total: 0,
    active: 0,
    closed: 0,
  });

  useEffect(() => {
    const fetchJobs = async () => {
      try {
        const userId = Cookies.get("id");
        const jobRes = await axios.get("/api/jobprofile/", {
          withCredentials: true,
        });
        const userJobs = jobRes.data.results.filter(
          (job) => String(job.created_by) === String(userId),
        );

        const total = userJobs.length;
        const active = userJobs.filter((job) => job.is_active).length;
        const closed = userJobs.filter((job) => !job.is_active).length;

        setUserJobStats({ total, active, closed });
      } catch (error) {
        console.error("Error while fetching stats", error);
      }
    };
    fetchJobs();
  }, []);

  return userjobStats;
}
